import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@ontruck/orc';
import { StyledContainer, StyledTitle, StyledDescription, StyledCloseButton } from './styled';

const ErrorFeedback = ({ handleCloseModal, show, title, description }) => {
  return (
    show && (
      <StyledContainer onClick={handleCloseModal}>
        <StyledCloseButton onClick={handleCloseModal}>
          <Icon glyph="close" size="1.4rem" />
        </StyledCloseButton>
        <StyledTitle>{title}</StyledTitle>
        <StyledDescription>{description}</StyledDescription>
      </StyledContainer>
    )
  );
};

ErrorFeedback.propTypes = {
  show: PropTypes.bool,
  title: PropTypes.string,
  description: PropTypes.string,
  handleCloseModal: PropTypes.func,
};

export default ErrorFeedback;
